import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {RouterService} from "../../services/router.service";

@Component({
  selector: 'entity-link',
  templateUrl: './entity-link.component.html'
})
export class EntityLinkComponent implements OnInit, OnChanges {

  @Input() item: any;
  @Input() type: 'store' | 'action' | 'product' | 'project' | 'purchase' | 'collection' | 'account' | 'user' | 'storeGroup' | 'storeVersion' | 'customData';
  @Input() name: string;
  @Input() info: string;
  @Input() bindLabel: string = 'name';
  @Input() bindInfo: string = 'id';
  @Input() bindRoute: string = 'id';
  @Input() strong: boolean = false;
  @Input() linkInfo: boolean = false;
  @Input() showInfo: boolean = true;
  @Input() showLink: boolean = true;
  @Input() relativePath: boolean = false;
  @Input() isEntity: boolean = false;

  viewName: string;
  viewInfo: string;
  route: string[] = [];
  paths: any = {
    ['store']: ['/', 'stores', 'view'],
    ['product']: ['/', 'products', 'view'],
    ['collection']: ['/', 'store-collections', 'view'],
    ['account']: ['/', 'accounts', 'view'],
    ['project']: ['/', 'projects', 'view'],
    ['purchase']: ['/', 'purchases', 'view'],
    ['user']: ['/', 'users', 'view'],
    ['storeGroup']: ['/', 'store-groups', 'edit'],
    ['customData']: ['/', 'custom-data', 'edit'],
    ['storeVersion']: ['/', 'store-versions', 'edit'],
    ['action']: ['/', 'actions', 'edit'],
  };

  constructor(private routerService: RouterService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('type' in changes || 'params' in changes) {
      this.route = [...(this.paths[this.type] || [])];

      if (!this.item) return;

      const params = this.item[this.bindRoute];

      this.route.push(params);
      this.route = this.routerService.getPath(this.route, this.relativePath, this.isEntity)
    }
  }
}
